import { moment } from "@msuite/utils/date";
import { InvoiceStatisticsChart } from "@/components/statistics/invoice-statistics-chart";

/** Props Interface */
interface ProjectInvoiceOverviewProps {
	projectId: string;
}

export function ProjectInvoiceOverview({ projectId }: ProjectInvoiceOverviewProps) {
	/** Render */
	return (
		<div className="w-full h-36">
			<InvoiceStatisticsChart
				query={{
					startDate: moment().startOf("year").format("YYYY-MM-DD"),
					endDate: moment().endOf("year").format("YYYY-MM-DD"),
					type: "project",
					truncateType: "week",
					projectId,
				}}
			/>
		</div>
	);
}
